
/**
 * Language
 */
export default class Language {

    /**
     * Begin Button
     *
     * @type {String}
     */
    public static readonly BTN_BEGIN: string = "Begin";

    /**
     * Download Button
     *
     * @type {String}
     */
    public static readonly BTN_DOWNLOAD: string = "Download";

    /**
     * Go Button
     *
     * @type {String}
     */
    public static readonly BTN_GO: string = "Go!";

    /**
     * Share Learn More
     *
     * @type {String}
     */
    public static readonly BTN_SHARE_LEARNMORE: string = "Learn More";

    /**
     * Share Play Again
     *
     * @type {String}
     */
    public static readonly BTN_SHARE_PLAYAGAIN: string = "Start Again";

    /**
     * Share Share
     *
     * @type {String}
     */
    public static readonly BTN_SHARE_SHARE: string = "Share";

    /**
     * Share Button
     *
     * @type {String}
     */
    public static readonly BTN_SHARE: string = "Share";

    /**
     * Share on Facebook Button
     *
     * @type {String}
     */
    public static readonly BTN_SHARE_FACEBOOK: string = "Share on Facebook";

    /**
     * Tweet Button
     *
     * @type {String}
     */
    public static readonly BTN_SHARE_TWITTER: string = "Tweet on Twitter";

    /**
     * Download Button
     *
     * @type {String}
     */
    public static readonly BTN_SHARE_DOWNLOAD: string = "Download";

    /**
     * Link to Listen to Orbit
     *
     * @type {String}
     */
    public static readonly LINK_LISTENTOORBIT: string =
        "http://smarturl.it/saturnlaunch/";

    /**
     * Link to Learn More
     *
     * @type {String}
     */
    public static readonly LINK_LEARNMORE: string =
        "http://microsoft.com/inculture/musicxtech/nao-ai-interactive-music-video/";

    /**
     * Link to Official Website
     *
     * @type {String}
     */
    public static readonly LINK_OFFICIALSITE: string =
        "https://thisnao.com";

    /**
     * Link to Privacy Policy
     *
     * @type {String}
     */
    public static readonly LINK_PRIVACYPOLICY: string =
        "https://www.playstation.com/en-us/network/legal/privacy-policy/";

    /**
     * Link to Terms and Conditions
     *
     * @type {String}
     */
    public static readonly LINK_TERMSANDCONDITIONS: string =
        "https://www.playstation.com/en-us/network/legal/terms-of-service/";

    /**
     * Link to Facebook Profile
     *
     * @type {String}
     */
    public static readonly LINK_FACEBOOK: string =
        "http://smarturl.it/NAOFB";

    /**
     * Link to Twitter Profile
     *
     * @type {String}
     */
    public static readonly LINK_TWITTER: string =
        "http://smarturl.it/NAOTW";

    /**
     * Link to Instagram Profile
     *
     * @type {String}
     */
    public static readonly LINK_INSTAGRAM: string =
        "http://smarturl.it/NAOIN";

    /**
     * Link to YouTube Profile
     *
     * @type {String}
     */
    public static readonly LINK_YOUTUBE: string =
        "http://smarturl.it/NAOYTC";

    /**
     * Link to Soundcloud Profile
     *
     * @type {String}
     */
    public static readonly LINK_SOUNDCLOUD: string =
        "https://www.soundcloud.com/";

    /**
     * Link to Spotify Profile
     *
     * @type {String}
     */
    public static readonly LINK_SPOTIFY: string =
        "https://www.spotify.com/";

    /**
     * Link to Email
     *
     * @type {String}
     */
    public static readonly LINK_EMAIL: string =
        "http://smarturl.it/NAOOrbitSignUp";

    /**
     * Caption when preloader is loading
     *
     * @type {String}
     */
    public static readonly PRELOADER_LOADING: string = "Loading";

    /**
     * Caption when preloader is complete
     *
     * @type {[type]}
     */
    public static readonly PRELOADER_COMPLETE: string = "Complete";

    public static readonly SHARE_URL: string = "https://thisnao.com?sign=";
    // public static readonly SHARE_BODY: string = "Share text goes here.";
    public static readonly SHARE_BODY: string = "Share text goes here.";
    public static readonly SHARE_HASHTAG: string = "OrbitByNAO";

    /**
     * Footer Follow
     *
     * @type {String}
     */
    public static readonly FOOTER_FOLLOW: string = "Follow Nao:";

    /**
     * Header Title
     *
     * @type {String}
     */
    public static readonly HEADER_TITLE: string = "Orbit By Nao";

    /**
     * Subtitle for the homepage
     *
     * @type {String}
     */
    public static readonly HOME_SUBTITLE: string = "An interactive music experience";

    /**
     * Paragraph for the homepage
     *
     * @type {String}
     */
    public static readonly HOME_PARAGRAPH: string = "";

    /**
     * Header caption for Birthdate
     *
     * @type {String}
     */
    public static readonly DATEPICKER_HEADER: string = "Enter Birthdate:";

    /**
     * "Day"
     *
     * @type {String}
     */
    public static readonly DAY: string = "DAY";

    /**
     * "Month"
     *
     * @type {String}
     */
    public static readonly MONTH: string = "MONTH";

    /**
     * "Year"
     *
     * @type {String}
     */
    public static readonly YEAR: string = "YEAR";

    /**
     * "Body Colour"
     *
     * @type {String}
     */
    public static readonly BODY_COLOR: string = "Body Colour";

    /**
     * "Body Density"
     *
     * @type {String}
     */
    public static readonly BODY_DENSITY: string = "Body Density";

    /**
     * "Star Colour"
     *
     * @type {String}
     */
    public static readonly STAR_COLOR: string = "Star Colour";

    /**
     * "Background"
     *
     * @type {String}
     */
    public static readonly BACKGROUND_COLOR: string = "Background Colour";

    /**
     * "Close"
     *
     * @type {String}
     */
    public static readonly CLOSE: string = "Close";

    /**
     * "Customize"
     *
     * @type {String}
     */
    public static readonly CUSTOMIZE: string = "Customize";

    /**
     * "Learn more"
     *
     * @type {String}
     */
    public static readonly LEARN_MORE: string = "Learn more";

}
